// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2Yf_G","cell":"ColumnAccessor_cell__3JQd9","firstCellAccent":"ColumnAccessor_firstCellAccent__38FIu"};